import React, { useState } from 'react';
import NavbarSwipeableDrawer from './navbar_swipeable_drawer';
import Anchor from '../shared/anchor';
import AuthHelper from '../../helpers/auth_helper';
import { KeyboardArrowDown as KeyboardArrowDownIcon } from '@mui/icons-material';
import Actions from '../../actions/actions';
import FunctionalityAccessHelper from '../../helpers/functionality_access_helper';
import FeaturePermissionsHelper from '../../helpers/feature_permissions_helper';
import { Button, Divider, List, ListItem, Menu, MenuItem } from '@mui/material';

const NavbarContent = ({ hamburgerMenu, userComplied, menuItems, user }) => {
  const resourcesLink = 'https://www.concertsolarfinancing.com/resources';

  let hasAccessToAdminPage =
    FunctionalityAccessHelper.hasAccessToAdmin(user) || FeaturePermissionsHelper.hasModule(user, 'admin');

  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const toggleDrawer = (open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setOpen(open);
  };

  const withHandleDrawer = (passThroughFunc) => (event) => {
    event.preventDefault();
    passThroughFunc();
    setOpen(false);
    handleUsernameMenuClose();
  };

  const handleUsernameMenuClick = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleUsernameMenuClose = () => {
    setAnchorEl(null);
  };

  const userLabel = () => {
    const impersonatedUser = AuthHelper.getImpersonateCookie();
    if (!user) {
      return '';
    } else if (impersonatedUser) {
      return `Impersonating ${user.firstname} ${user.lastname}`;
    }
    return `${user.firstname} ${user.lastname}`;
  };

  const goToAccount = () => {
    Actions.setRoute('/account-details');
    Actions.setView({ page: 'accountDetails' });
  };

  const goToAdminLandingPage = () => {
    Actions.clearCompanyList();
    switch (user.atype) {
      case 'CPF':
        Actions.clearCompanyList();
        Actions.setRoute('/account/companies');
        break;
      default:
        Actions.setRoute(`/account/companies/${user.company.coid}/users?type=active`);
        break;
    }
  };

  const onLogOut = () => {
    Actions.logOut({ timedOut: false });
  };

  return hamburgerMenu ? (
    <NavbarSwipeableDrawer className="mobile-menu" open={open} toggleDrawer={toggleDrawer}>
      <ListItem>
        <span className="header-text user-label">{userLabel()}</span>
      </ListItem>
      <Divider />
      <List className="drawer-nav-list">
        {menuItems.map((item, i) => (
          <Button key={i} className="list-item">
            {item}
          </Button>
        ))}
        {
          <a
            className={'header-text list-item'}
            href={resourcesLink}
            target={'_blank'}
            rel={'noopener noreferrer'}
            id={'resources-link'}
            style={{
              fontSize: '12.25px',
              fontFamily: 'poppins',
              fontWeight: 500,
              textAlign: 'center',
              paddingTop: '7px',
              paddingBottom: '7px',
            }}
          >
            RESOURCES
          </a>
        }
        <Divider />
        <Button className="list-item">
          <Anchor className="header-text" onClick={withHandleDrawer(goToAccount)} id="settings-link">
            My Settings
          </Anchor>
        </Button>
        {userComplied && hasAccessToAdminPage && (
          <Button className="list-item">
            <Anchor className="header-text" onClick={withHandleDrawer(goToAdminLandingPage)} id="admin-link">
              Admin
            </Anchor>
          </Button>
        )}
        <div className="spacer" />
      </List>
      <Divider />
      <Button className="log-out-button">
        <Anchor className="log-out" onClick={withHandleDrawer(onLogOut)} id="logout-link">
          LOGOUT
        </Anchor>
      </Button>
    </NavbarSwipeableDrawer>
  ) : (
    <div className="header-links desktop-menu">
      {menuItems}
      <a
        href={resourcesLink}
        target={'_blank'}
        rel={'noopener noreferrer'}
        id={'resources-link'}
        style={{ fontSize: '12px', padding: '0 9px' }}
      >
        Resources
      </a>
      &nbsp;|&nbsp;
      <span className="header-text">
        <Button
          id={'dropdownMenuButton'}
          aria-controls={'username-menu'}
          aria-haspopup={true}
          onClick={handleUsernameMenuClick}
          style={{ color: 'white', lineHeight: '42px', padding: 0, textTransform: 'none', fontWeight: 'normal' }}
        >
          <span id="qa-user-label" className="user-label">
            {userLabel()}
          </span>
          {<KeyboardArrowDownIcon />}
        </Button>
        <Menu
          id={'username-menu'}
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: 42, horizontal: 'left' }}
          // getContentAnchorEl={null}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleUsernameMenuClose}
        >
          <MenuItem id="settings-link" onClick={withHandleDrawer(goToAccount)}>
            My Settings
          </MenuItem>
          {userComplied && hasAccessToAdminPage && (
            <MenuItem id="admin-link" onClick={withHandleDrawer(goToAdminLandingPage)}>
              Admin
            </MenuItem>
          )}
          <MenuItem className={'log-out'} id="logout-link" onClick={withHandleDrawer(onLogOut)}>
            Logout
          </MenuItem>
        </Menu>
      </span>
    </div>
  );
};

export default NavbarContent;
